export default __webpack_public_path__ + "static/media/album-image-1.d4aaae13.svg";